import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedRockChartModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Rock Chart (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-rockchart"
      icon="solar:ranking-bold"
      instructions={[
        "Wear red and blue glasses.",
        "Type the letters appearing on the screen using your keyboard."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedRockChartModal;
